import NProgress from 'nprogress';

/**
 * 设置NProgress插件
 */
export function setupNProgress() {
  NProgress.configure({ easing: 'ease', speed: 500 });

  // mount on window
  window.NProgress = NProgress;
}
